"use client"

import { useEffect, useState } from "react"
import axios from "axios"
import { useNavigate } from "react-router-dom"
import { FaPlus, FaEdit, FaTrash, FaEllipsisV, FaCalendarAlt, FaLock, FaLockOpen, FaClock } from "react-icons/fa"
import "../styles/dashboardEventos.css"

const DELETE_EVENT_PASSWORD = process.env.REACT_APP_DELETE_EVENT_PASSWORD || "254595";

const DashboardEventos = () => {
  const [eventos, setEventos] = useState([])
  const [eventosFiltrados, setEventosFiltrados] = useState([]) // Eventos após filtragem
  const [busca, setBusca] = useState("") // Campo de busca
  const [loading, setLoading] = useState(true)
  const [modalAberto, setModalAberto] = useState(false)
  const [eventoEditando, setEventoEditando] = useState(null)
  const [imagemPreview, setImagemPreview] = useState(null)
  const [menuAbertoId, setMenuAbertoId] = useState(null)
  const navigate = useNavigate()
  const token = localStorage.getItem("token")
  const [categorias, setCategorias] = useState([]);
  const [eventoSelecionado, setEventoSelecionado] = useState(null);

  // 🔐 estado do modal de exclusão com senha
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [deletePassword, setDeletePassword] = useState("");
  const [eventoParaExcluir, setEventoParaExcluir] = useState(null);

  // 🔹 Função para carregar eventos do backend
  const carregarEventos = async () => {
    try {
      setLoading(true)
      const response = await axios.get("https://api.ticketdovaqueiro.com/api/events", {
        headers: { Authorization: `Bearer ${token}` },
      })
      setEventos(response.data)
      setEventosFiltrados(response.data) // Mantém os eventos filtrados sincronizados
      setLoading(false)
    } catch (error) {
      console.error("❌ Erro ao carregar eventos:", error)
      setLoading(false)
    }
  }

  const toggleMenu = (eventoId) => {
    if (menuAbertoId === eventoId) {
      setMenuAbertoId(null)
    } else {
      setMenuAbertoId(eventoId)
    }
  }

  // Fechar menu ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuAbertoId && !event.target.closest(".acoes-cell")) {
        setMenuAbertoId(null)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [menuAbertoId])

  useEffect(() => {
    carregarEventos()
  }, [])

  // 🔹 Filtrar eventos pelo nome
  const handleBuscaChange = (e) => {
    const termo = e.target.value.toLowerCase()
    setBusca(termo)
    setEventosFiltrados(eventos.filter((evento) => evento.nome.toLowerCase().includes(termo)))
  }

  const mudarStatus = async (eventoId, novoStatus) => {
    try {
      await axios.put(
        `https://api.ticketdovaqueiro.com/api/events/${eventoId}/status`,
        { novoStatus },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      )
      alert(`Status alterado para ${novoStatus}`)
      carregarEventos()
    } catch (err) {
      alert("Erro ao mudar status!")
    }
  }

  // 🔐 Abre modal pedindo senha para exclusão
  const abrirModalExcluir = (evento) => {
    setEventoParaExcluir(evento);
    setDeletePassword("");
    setConfirmDeleteOpen(true);
    setMenuAbertoId(null);
  };

  const fecharModalExcluir = () => {
    setConfirmDeleteOpen(false);
    setEventoParaExcluir(null);
    setDeletePassword("");
  };

  // 🔥 Confirma exclusão com senha
  const handleConfirmDelete = async () => {
    if (!eventoParaExcluir) return;

    if (deletePassword !== DELETE_EVENT_PASSWORD) {
      alert("Senha de segurança incorreta!");
      return;
    }

    try {
      await axios.delete(`https://api.ticketdovaqueiro.com/api/events/${eventoParaExcluir._id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      alert("Evento excluído com sucesso!")
      fecharModalExcluir();
      carregarEventos()
    } catch (error) {
      console.error("❌ Erro ao excluir evento:", error)
      alert("Erro ao excluir evento!")
    }
  }

  // 🔹 Função para encerrar vendas do evento
  const encerrarVendas = async (id) => {
    if (window.confirm("Deseja encerrar as vendas deste evento?")) {
      try {
        await axios.put(
          `https://api.ticketdovaqueiro.com/api/events/${id}/encerrar`,
          {},
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        )
        alert("Vendas encerradas com sucesso!")
        carregarEventos()
      } catch (error) {
        console.error("❌ Erro ao encerrar vendas:", error)
        alert("Erro ao encerrar vendas!")
      }
    }
  }

  const abrirModalEditar = (evento) => {
    setEventoSelecionado({ ...evento })
    setImagemPreview(null)
    setModalAberto(true)
    setCategorias(evento.categorias || []);
  }
  

  const fecharModal = () => {
    setModalAberto(false)
    setEventoEditando(null)
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setEventoEditando({ ...eventoEditando, [name]: value })
  }

  const handleFileChange = (e) => {
    const file = e.target.files[0]
    setEventoEditando({ ...eventoEditando, novaImagem: file })

    if (file) {
      const reader = new FileReader()
      reader.onloadend = () => {
        setImagemPreview(reader.result)
      }
      reader.readAsDataURL(file)
    }
  }

  const salvarEdicao = async () => {
    try {
      const formData = new FormData()
      formData.append("nome", eventoEditando.nome)
      formData.append("descricao", eventoEditando.descricao)
      formData.append("dataInicio", eventoEditando.dataInicio)
      formData.append("dataFim", eventoEditando.dataFim)
      formData.append("dataEvento", eventoEditando.dataEvento)
      formData.append("taxaDono", eventoEditando.taxaDono)
      formData.append("taxaCliente", eventoEditando.taxaCliente)
      formData.append("status", eventoEditando.status)
      formData.append('categorias', JSON.stringify(categorias));
      if (eventoEditando.novaImagem) {
        formData.append("imagem", eventoEditando.novaImagem)
      }

      await axios.put(`https://api.ticketdovaqueiro.com/api/events/${eventoEditando._id}`, formData, {
        headers: { Authorization: `Bearer ${token}` },
      })
      alert("Evento atualizado com sucesso!")
      fecharModal()
      carregarEventos()
    } catch (err) {
      console.error("Erro ao editar evento", err)
      alert("Erro ao editar evento")
    }
  }

  // Função para renderizar o ícone de status
  const renderStatusIcon = (status) => {
    switch (status) {
      case "aberto":
        return <FaLockOpen className="status-icon" />
      case "encerrado":
        return <FaLock className="status-icon" />
      case "em breve":
        return <FaClock className="status-icon" />
      default:
        return null
    }
  }
  const adicionarCategoria = () => {
    setCategorias([
      ...categorias,
      {
        nome: '',
        dias: [],
        precoSenha1: 0,
        boiTv1: false,
        precoSenha2: 0,
        boiTv2: false,
        precoSenha3: 0,
        boiTv3: false
      }
    ]);
  };
  
  const removerCategoria = (index) => {
    const novas = [...categorias];
    novas.splice(index, 1);
    setCategorias(novas);
  };
  const handleSalvarEdicao = async () => {
    try {
      const formData = new FormData();
      for (const key in eventoSelecionado) {
        if (key === "categorias") {
          formData.append("categorias", JSON.stringify(eventoSelecionado.categorias));
        } else {
          formData.append(key, eventoSelecionado[key]);
        }
      }
  
      await axios.put(`/api/eventos/${eventoSelecionado._id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
  
      alert("Evento atualizado com sucesso!");
      setEventoSelecionado(null);
      carregarEventos();
 // atualiza lista
    } catch (error) {
      console.error("Erro ao atualizar evento:", error);
      alert("Erro ao atualizar o evento.");
    }
  };
  
  const atualizarCampoCategoria = (index, campo, valor) => {
    const novas = [...categorias];
    novas[index][campo] = valor;
    setCategorias(novas);
  };
  
  const atualizarDiasCategoria = (index, diaSelecionado) => {
    const novas = [...categorias];
    const dias = novas[index].dias;
  
    if (dias.includes(diaSelecionado)) {
      novas[index].dias = dias.filter((dia) => dia !== diaSelecionado);
    } else {
      novas[index].dias = [...dias, diaSelecionado];
    }
  
    setCategorias(novas);
  };
  
  // Função para renderizar o badge de status
  const renderStatusBadge = (status) => {
    let className = ""

    switch (status) {
      case "aberto":
        className = "status-aberto"
        break
      case "encerrado":
        className = "status-encerrado"
        break
      case "em breve":
        className = "status-em-breve"
        break
      default:
        className = ""
    }

    return (
      <span className={`status-badge ${className}`}>
        {renderStatusIcon(status)} {status}
      </span>
    )
  }

  return (
    <div className="admin-layout1">
      <div className="admin-content1">
        <h1 className="titulo-eventos">Gerenciar Eventos</h1>

        {/* 🔍 Campo de busca e botão de criação */}
        <div className="busca-container">
          <input
            type="text"
            className="campo-busca"
            placeholder="Buscar evento pelo nome..."
            value={busca}
            onChange={handleBuscaChange}
          />
          <button className="botao-criar-evento" onClick={() => navigate("/admin/criar-evento")}>
            <FaPlus /> Criar Novo Evento
          </button>
        </div>

        {/* ⏳ Mensagem de carregamento */}
        {loading ? (
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <p>Carregando eventos...</p>
          </div>
        ) : eventosFiltrados.length === 0 ? (
          <div className="no-events">
            <p>Nenhum evento encontrado.</p>
          </div>
        ) : (
          <div className="table-container">
            <table className="tabela-eventos">
              <thead>
                <tr>
                  <th>Imagem</th>
                  <th>Nome</th>
                  <th>Data do Evento</th>
                  <th>Status</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {eventosFiltrados.map((evento) => (
                  <tr key={evento._id}>
                    <td>
                      <img
                        src={`https://api.ticketdovaqueiro.com/uploads/${evento.imagem}`}
                        alt={evento.nome}
                        className="imagem-evento"
                        onError={(e) => (e.target.src = "/default.jpg")} // 🔹 Se a imagem não carregar, usa uma padrão
                      />
                    </td>
                    <td>{evento.nome}</td>
                    <td>
                      <FaCalendarAlt className="calendar-icon" />
                      {evento.dataEvento
                        ? new Date(evento.dataEvento).toLocaleDateString("pt-BR")
                        : "Data não disponível"}
                    </td>
                    <td>{renderStatusBadge(evento.status)}</td>
                    <td className="acoes-cell">
                      <button className="menu-icon" onClick={() => toggleMenu(evento._id)}>
                        <FaEllipsisV />
                      </button>
                      {menuAbertoId === evento._id && (
                        <div className="menu-suspenso24">
                          <button onClick={() => navigate(`/admin/editar-evento/${evento._id}`)}>
                            <FaEdit /> Editar
                          </button>
                          <button onClick={() => abrirModalExcluir(evento)}>
                            <FaTrash /> Excluir
                          </button>
                          <button onClick={() => mudarStatus(evento._id, "aberto")}>
                            <FaLockOpen /> Abrir
                          </button>
                          <button onClick={() => mudarStatus(evento._id, "encerrado")}>
                            <FaLock /> Encerrar
                          </button>
                          <button onClick={() => mudarStatus(evento._id, "em breve")}>
                            <FaClock /> Em Breve
                          </button>
                          <button onClick={() => mudarStatus(evento._id, "ocultado")}>
                            ❌ Ocultar
                          </button>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* MODAL EDITAR */}
        {modalAberto && eventoSelecionado && (
  <div className="modal-editar">
    <div className="modal-content">
      <h3>Editar Evento</h3>

      <label>Nome do Evento</label>
      <input
        type="text"
        value={eventoSelecionado.nome}
        onChange={(e) => setEventoSelecionado({ ...eventoSelecionado, nome: e.target.value })}
      />

      <label>Descrição</label>
      <textarea
        value={eventoSelecionado.descricao}
        onChange={(e) => setEventoSelecionado({ ...eventoSelecionado, descricao: e.target.value })}
      />

      <label>Premiação</label>
      <input
        type="text"
        value={eventoSelecionado.premiacao}
        onChange={(e) => setEventoSelecionado({ ...eventoSelecionado, premiacao: e.target.value })}
      />

      <label>Data de Início</label>
      <input
        type="date"
        value={eventoSelecionado.dataInicio?.substring(0, 10)}
        onChange={(e) => setEventoSelecionado({ ...eventoSelecionado, dataInicio: e.target.value })}
      />

      <label>Data do Evento</label>
      <input
        type="date"
        value={eventoSelecionado.dataEvento?.substring(0, 10)}
        onChange={(e) => setEventoSelecionado({ ...eventoSelecionado, dataEvento: e.target.value })}
      />

      <label>Data de Encerramento</label>
      <input
        type="date"
        value={eventoSelecionado.dataFim?.substring(0, 10)}
        onChange={(e) => setEventoSelecionado({ ...eventoSelecionado, dataFim: e.target.value })}
      />

      <label>Taxa do Dono (%)</label>
      <input
        type="number"
        value={eventoSelecionado.taxaDono || 0}
        onChange={(e) => setEventoSelecionado({ ...eventoSelecionado, taxaDono: e.target.value })}
      />

      <label>Taxa do Cliente (%)</label>
      <input
        type="number"
        value={eventoSelecionado.taxaCliente || 0}
        onChange={(e) => setEventoSelecionado({ ...eventoSelecionado, taxaCliente: e.target.value })}
      />

      <label>Status</label>
      <select
        value={eventoSelecionado.status}
        onChange={(e) => setEventoSelecionado({ ...eventoSelecionado, status: e.target.value })}
      >
        <option value="aberto">Aberto</option>
        <option value="em breve">Em breve</option>
        <option value="encerrado">Encerrado</option>
        <option value="ocultado">Ocultado</option>
      </select>

      <hr />
      <h4>Categorias</h4>

      {eventoSelecionado.categorias?.map((cat, idx) => (
        <div key={idx} className="categoria-bloco">
          <label>Nome da Categoria</label>
          <input
            type="text"
            value={cat.nome}
            onChange={(e) => {
              const novas = [...eventoSelecionado.categorias];
              novas[idx].nome = e.target.value;
              setEventoSelecionado({ ...eventoSelecionado, categorias: novas });
            }}
          />

          <label>Dias (separar por vírgula)</label>
          <input
            type="text"
            value={cat.dias?.join(", ") || ""}
            onChange={(e) => {
              const novas = [...eventoSelecionado.categorias];
              novas[idx].dias = e.target.value.split(",").map((d) => d.trim());
              setEventoSelecionado({ ...eventoSelecionado, categorias: novas });
            }}
          />

          {[1, 2, 3].map((nivel) => (
            <div key={nivel} className="bloco-preco-boitv">
              <label>Preço Senha {nivel}</label>
              <input
                type="number"
                value={cat[`precoSenha${nivel}`] || ""}
                onChange={(e) => {
                  const novas = [...eventoSelecionado.categorias];
                  novas[idx][`precoSenha${nivel}`] = e.target.value;
                  setEventoSelecionado({ ...eventoSelecionado, categorias: novas });
                }}
              />
              <label>
                <input
                  type="checkbox"
                  checked={cat[`boiTv${nivel}`] || false}
                  onChange={(e) => {
                    const novas = [...eventoSelecionado.categorias];
                    novas[idx][`boiTv${nivel}`] = e.target.checked;
                    setEventoSelecionado({ ...eventoSelecionado, categorias: novas });
                  }}
                />
                BoiTV
              </label>
            </div>
          ))}

          <button onClick={() => {
            const novas = [...eventoSelecionado.categorias];
            novas.splice(idx, 1);
            setEventoSelecionado({ ...eventoSelecionado, categorias: novas });
          }}>🗑 Remover Categoria</button>
        </div>
      ))}

      <button
        type="button"
        onClick={() =>
          setEventoSelecionado({
            ...eventoSelecionado,
            categorias: [...eventoSelecionado.categorias, {
              nome: "",
              dias: [],
              precoSenha1: 0,
              boiTv1: false,
              precoSenha2: 0,
              boiTv2: false,
              precoSenha3: 0,
              boiTv3: false
            }]
          })
        }
      >
        ➕ Adicionar Categoria
      </button>

      <div className="botoes-modal">
        <button onClick={handleSalvarEdicao}>💾 Salvar</button>
        <button onClick={() => setModalAberto(false)}>❌ Cancelar</button>
      </div>
    </div>
  </div>
)}

        {/* MODAL EXCLUIR COM SENHA */}
        {confirmDeleteOpen && (
          <div
            className="modal-excluir-overlay"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              background: "rgba(0,0,0,0.6)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 9999
            }}
          >
            <div
              className="modal-excluir-content"
              style={{
                background: "#fff",
                padding: "20px",
                borderRadius: "8px",
                maxWidth: "400px",
                width: "90%",
                boxShadow: "0 10px 25px rgba(0,0,0,0.3)"
              }}
            >
              <h3 style={{ marginBottom: "10px" }}>Confirmar exclusão</h3>
              <p style={{ marginBottom: "10px" }}>
                Para excluir o evento <strong>{eventoParaExcluir?.nome}</strong>, digite a senha de segurança.
              </p>

              <input
                type="password"
                placeholder="Senha de segurança"
                value={deletePassword}
                onChange={(e) => setDeletePassword(e.target.value)}
                style={{
                  width: "100%",
                  padding: "8px",
                  marginTop: "8px",
                  marginBottom: "16px",
                  borderRadius: "4px",
                  border: "1px solid #ccc"
                }}
              />

              <div style={{ display: "flex", justifyContent: "space-between", gap: "10px" }}>
                <button
                  onClick={fecharModalExcluir}
                  style={{
                    flex: 1,
                    background: "#6c757d",
                    color: "#fff",
                    padding: "8px",
                    borderRadius: "4px",
                    border: "none",
                    cursor: "pointer"
                  }}
                >
                  Cancelar
                </button>
                <button
                  onClick={handleConfirmDelete}
                  style={{
                    flex: 1,
                    background: "#dc3545",
                    color: "#fff",
                    padding: "8px",
                    borderRadius: "4px",
                    border: "none",
                    cursor: "pointer"
                  }}
                >
                  Excluir
                </button>
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  )
}

export default DashboardEventos
